import {Box} from "@mui/material";
import NextLink from "next/link";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import SocialItem from "@/src/_types/social-item";

export default function SocialIcon({item}: { item: SocialItem }) {
    return (
        <Box
            sx={{
                position: "relative",
                perspective: "1000px",
                "& a": {
                    display: "block",
                    backgroundColor: "#0c7f8b",
                    padding: "1rem",
                    color: "white",
                    textAlign: "center",
                    textDecoration: "none",
                    transform: "perspective(1000px) rotate(-30deg) skew(25deg) translate(0, 0)",
                    boxShadow: "-15px 15px 7.5px rgba(51,51,51,0.8)",
                    transition: "all 0.5s ease-in-out",
                },
                "& a:hover": {
                    transform: "rotate(-30deg) skew(25deg) translate(15px, -15px)",
                    boxShadow: "-30px 30px 20px rgba(51,51,51,0.8)",
                },
                "& a::before": {
                    content: '""',
                    position: 'absolute',
                    width: '.75rem',
                    height: '100%',
                    left: '-.75rem',
                    top: '.4rem',
                    background: 'rgba(11, 116, 127, 0.7)',
                    transform: 'rotate(0deg) skewY(-45deg)',
                },
                "& a::after": {
                    content: '""',
                    position: 'absolute',
                    height: '.75rem',
                    width: '100%',
                    bottom: '-.75rem',
                    left: '-.4rem',
                    background: 'rgba(11, 116, 127, 0.7)',
                    transform: 'rotate(0deg) skewX(-45deg)',
                },
            }}
        >
            <NextLink href={item.link} title={item.title}>
                <FontAwesomeIcon icon={item.icon} fontSize="large"/>
            </NextLink>
        </Box>
    );
}
